export default __webpack_public_path__ + "static/media/igHead.f306c6b6.png";